import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import React from "react";
import { Avatar } from "@mui/material";
import { IconButton, Grid } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FooterNav from "../FooterNav";
import { unsetCookie } from "../Login";
import Models from "../Wallet/Component/Models";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserData } from "../../redux/slices/userInfo";
import { setOpen, toggleOpen } from "../../redux/slices/alertOpen";
import Cookies from "js-cookie";
import axiosInstance from "../../AxiosBaseApi";

const items = [
  // {
  //   label: "Personal information",
  //   src: "/images/my_list_01.png",
  //   path: "/personalinfo",
  // },
  { label: "Recharge Record", src: "/images/img2.png", path: "/wallet/rechargerecord" },
  {
    label: "Withdrawal Record",
    src: "/images/img3.png",
    path: "/financialrecords",
  },
  { label: "Message", src: "/images/img4.png", path: "/message" },
  { label: "Invite", src: "/images/img5.png", path: "/share" },
  {
    label: "Daily Statement",
    src: "/images/img6.png",
    path: "/dailystatemant",
  },
  { label: "Team Reports", src: "/images/img7.png", path: "/teamreport" },
  { label: "Fund Transfer", src: "/images/img3.png", path: "/fundtransfer" },
  
  // { label: "About Us", src: "/images/img8.png", path: "/about" },
  { label: "Employee Handbook", src: "/images/img9.png", path: "/ehbook" },
  // { label: "Download App", src: "/images/img10.png", path: "" },
  // { label: "Log out", src: "/images/img11.png", path: '' },
];

const My = () => {
  const userInfo = useSelector((state) => state.userdata);
  const openalert = useSelector((state) => state.openAlert);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, SetData] = useState("");

  const handleOpen = () => {
    dispatch(setOpen(true)); // Sets state to true
  };

  const handleClose = () => dispatch(toggleOpen());

  const getUserData = async (uid) => {
    try {
      const response = await axiosInstance
        .get(`/bet.php?action=getuserinfo&user=${uid}`)

        .then((res) => {
          if (res.status === 200) {
            SetData(res.data);
          } else {
            alert(res.data.message);
          }
        });
    } catch (error) {
      console.log("Error", error);
    }
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = 'https://taskapi.demovt360.xyz/app-release.apk';
    link.download = 'app-release.apk';  // You can give it a custom name if you want
    link.click();  // Trigger the download
  };

  useEffect(() => {
    const token = localStorage.getItem("mamberId");
    if (!token) {
      navigate("/login");
    } else {
      getUserData(token);
    }
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
  };

  const logOut = () => {
    localStorage.clear();
    navigate("/login");
  };
  return (
    <>
      <div
        style={{
          marginBottom: "100px",
          width: "100%",
          // height: "2vh",
          background: "url(/images/back.png) top / 100% 200px no-repeat",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            padding: 2,
            height: "25vh",
          }}
        >
          <img
            src="images/imgmy.png"
            alt="Icon"
            style={{ width: 60, height: 60, borderRadius: 30 }}
          />

          <Box>
            <Typography variant="body2" color="#3d3b6f">
              {data[0]?.username}
            </Typography>
          </Box>

          <Typography variant="body2" color="#3d3b6f">
            Nick Name: {data[0]?.nickname}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
         
            gap: 1,
          }}
        >
          {items.map((data, ind) => {
            return (
              <Box
                key={ind}
                onClick={() => handleNavigation(data.path)}
                style={{
                  width: "90%",
                  display: "flex",
                  borderBottom: "1px solid #ddd",
                  justifyContent: "space-between",
                  padding: "5px",
                  borderRadius: "5px",
                  // Margin:'12px',
                  background:"#3d3b6f",
                }}
              >
                <Box style={{ display: "flex", alignItems: "center", gap: 5 }}>
                  <img width={35} src={data.src} alt="" />
                  <Typography color="#fff" variant="body2">
                    {data.label}
                  </Typography>
                </Box>
                <Box>
                  <IconButton>
                    <ArrowForwardIosIcon style={{ color: "#fff" }} />
                  </IconButton>
                </Box>
              </Box>
            );
          })}
        </Box>


        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: 1,
            marginTop: "10px"
          }}
        >
          {/* {items.map((data, ind) => { */}
            {/* return ( */}
              <Box
     
                onClick= {() => logOut()}
                style={{
                  width: "90%",
                  display: "flex",
                  borderBottom: "1px solid #ddd",
                  justifyContent: "space-between",
                  padding: "5px",
                  borderRadius: "5px",
        
                  background:"#3d3b6f",
                }}
              >
                <Box style={{ display: "flex", alignItems: "center", gap: 5 }}>
                  <img width={35} src="/images/img11.png" alt="" />
                  <Typography color="#fff" variant="body2">
                   Logout
                  </Typography>
                </Box>
                <Box>
                  <IconButton>
                    <ArrowForwardIosIcon style={{ color: "#fff" }} />
                  </IconButton>
                </Box>
              </Box>
            {/* );
          })} */}
        </Box>


        {/* <Box
          sx={{
            // minHeight: 180,
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: 4,
            margin: "10px",
                  background:"#77769e", height: "50px" 
          }}
        >
          {[
            {
              label: "Personal information",
              src: "/images/my_list_01.png",
              path: () => handleNavigation("/personalinfo"),
            },
            {
              label: "About Us",
              src: "/images/img8.png",
              path: () => handleNavigation("/about"),
            },
            {
              label: "Download App",
              src: "/images/img10.png",
              path: () => handleDownload(),
            },
            {
              label: "Log out",
              src: "/images/img11.png",
              path: () => logOut(),
            },
          ].map((item, index) => (
            <Grid
              key={index}
              item
              style={{ width: "50px", height: "50px" }}
              onClick={item.path}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: item.path ? "pointer" : "default",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <img
                  style={{
                    padding: "10px",
                    backgroundColor: "#fff",
                    borderRadius: "36px",
                  }}
                  width={50}
                  src={item.src}
                  alt=""
                />
                <Typography
                  variant="subtitle1"
                  style={{ color: "#fff", lineHeight: 1, textAlign: "center" }}
                >
                  {item.label}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Box> */}

      </div>
        {/* <Box style={{ marginTop: "120px" }}> */}
          <FooterNav />
        {/* </Box> */}
    </>
  );
};
export default My;
